import { useEffect, useState } from "react";
import { Card } from "antd";
import ManageTeamCard from "../../common/manageTeamCard";
import Back from "../../../assets/icons/back.svg";
import { Link } from "react-router-dom";
import classes from "./index.module.css";
import DeleteMemberModal from "../../common/modalMember";
import InvitationSentCard from "../../common/invitationSentCard";
import Member from "../../../assets/icons/manageTeamMember.svg";
import { useDispatch, useSelector } from "react-redux";
import { fetchTeamMembers } from "../../../store/slices/teamSlice";
import { deleteTeamMembers } from "../../../api/business";

const ManageTeams = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [inviteCard, setInviteCard] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [isDeleted, setIsDeleted] = useState(false);
  const [memberName, setMemberName] = useState("");
  const dispatch = useDispatch();
  const teamData = useSelector((state) => state.team.response);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const resetInviteCard = () => {
    setInviteCard(false);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  const showModal = (id) => {
    setIsModalOpen(true);
    setSelectedId(id);
  };
  const hideModal = () => {
    setIsModalOpen(false);
  };
  const YesClickHandler = async () => {
    setIsModalOpen(false);
    try {
      await deleteTeamMembers(selectedId);
      const selectedTeamMember = teamData?.find(
        (member) => member?._id === selectedId
      );
      setMemberName(
        selectedTeamMember?.firstName + " " + selectedTeamMember?.lastName
      );
      setIsDeleted(true);
      setInviteCard(true);
    } catch (error) {}
  };
  const strokeColor = isHovered ? classes.strokeWhite : classes.strokePurple;

  useEffect(() => {
    dispatch(fetchTeamMembers());
  }, [isDeleted, dispatch]);

  return (
    <>
      {inviteCard ? (
        <div className="p-4">
          <InvitationSentCard
            img={Member}
            text={`${memberName} Was Deleted From Your Team`}
            showCard={resetInviteCard}
          />
        </div>
      ) : (
        <div className={`relative ${isModalOpen ? "blur-sm" : ""}`}>
          <div className="grid gap-2 space-x-3 w-full">
            <div className="flex pt-3 pl-3">
              <Link to="/main/profile">
                <div className="flex items-center">
                  <img src={Back} alt="Edit Icon" className="mr-1" />
                  <span className="text-lg font-bold text-black ml-1">
                    Manage Team
                  </span>
                </div>
              </Link>
            </div>
            <div className="space-y-2">
              {teamData?.map((data) => (
                <ManageTeamCard
                  key={data._id}
                  edit={true}
                  openModal={() => showModal(data._id)}
                  member={`${data.firstName} ${data.lastName}`}
                  email={data.email}
                  phone={data.phoneNumber}
                />
              ))}
            </div>
            <div className="xl:w-111.7">
              <Link to="/main/profile/invite-member">
                <Card
                  className="border-2 border-gray-200 flex items-center justify-center xl:mr-0 mr-2 xl:w-111.7 h-11.4 bg-white hover:bg-primaryPurple cursor-pointer group hover:text-white"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  <div className="flex flex-col">
                    <div className="flex flex-col items-center">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`w-2 h-2 ${strokeColor} transition-all `}
                      >
                        <path
                          id="Vector"
                          d="M2 12H22M12 2V22"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <p className="font-medium text-primaryPurple mt-0 group-hover:text-white">
                        Add New Member
                      </p>
                    </div>
                  </div>
                </Card>
              </Link>
            </div>
            {isModalOpen && (
              <DeleteMemberModal
                id={selectedId}
                title="Delete Member"
                text="Are you sure you want to delete member?"
                onCancel={hideModal}
                onOk={YesClickHandler}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};
export default ManageTeams;
